import React, {useState, useEffect} from "react";
import {Stack, Box, styled, Input, Button} from "@mui/material";
import Select from "react-select";
import {Badge, theme } from "@material-ui/core";



const TXTRoundedDiv = styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    marginBottom: "10px",
    width: "100%"
  }));
  
  const StyledBox = styled(Box)({
    marginBottom: "5px",
    marginTop: "5px",
    marginLeft: "5px",
  });
  
  const StyledInput = styled(Input)({
    width: "100%",
    height: "95%",
    fontSize: "14px",
    marginTop: "2px",
    marginBottom: "2px"
  });
  
  const StyledSelect = styled(Select)({
      width: "100%",
      height: "95%",
      fontSize: "14px",
      marginTop: "2px",
      marginBottom: "2px"
  });
  

  export default function FormWebTeam (props) {
    
    const [errors, setErrors]=useState({})
    const [formData, setFormData]=useState(
        {
          first_name: '',
          middle_name: '',
          last_name: '',
          title: '',
          image: '',
        }
    );
    const [picFile , setPicFile]=useState(false);
    const [image, setImage]=useState(null);

    const onChangeInput = (e) =>{
      const {name, value} = e.target 
      
      setFormData({
        ...formData,
        [name]: value
      })
      
      setErrors({});
    }
    
    const validateForm = (data) => {
     const errors={};
      
     console.log("INSIDE validateForm data.last_name='" + data.last_name + "'");
     
     if(!(data.first_name).trim()){
        errors.first_name='First name is required';
      }

      if(!(data.middle_name).trim()){
        errors.middle_name='Middle name is required';
      }
      
      if(!(data.last_name).trim()){
        errors.last_name='Last name is required';
      }

      if(!(data.title).trim()){
        errors.title='Title is required';
      }
      
      return errors;
    };

   const onButtonSubmit = (e) =>{
    const newErrors=  validateForm(formData);
    setErrors(newErrors);
    
    if(errors.length===0){

    }
    else{

    }
    console.log("formData.first_name=" + formData.first_name);
    console.log("formData.middle_name=" + formData.middle_name);
    console.log("formData.last_name=" + formData.last_name);
    console.log("formData.title=" + formData.title);
    
   }
  
   const onChangeImage=(e)=>{
     //formData.append({"img", e.target.files[0], e.target.name})
     setImage(e.target.files[0]);
     setPicFile(URL.createObjectURL(e.target.files[0]));
   }
   
   return (
    <Stack direction="row" spacing={1}>
       <StyledBox flex={4}>
            <TXTRoundedDiv>
              <StyledInput
              placeholder="First name"
              name="first_name"
              onChange={(e)=>onChangeInput(e)}
              
              />
              {errors.first_name && (
                <span>
                {errors.first_name}
                </span>
              )}
            </TXTRoundedDiv>
            <TXTRoundedDiv>
              <StyledInput
              placeholder="Middle name"
              name="middle_name"
              onChange={(e)=>onChangeInput(e)}
              
              />
              {errors.middle_name && (
                <span>
                    {errors.middle_name}
                </span>
              )}
            </TXTRoundedDiv>
            <TXTRoundedDiv>
              <StyledInput
              placeholder="Last name"
              name="last_name"
              onChange={(e)=>onChangeInput(e)}
              />
              {errors.last_name && (
                <span>
                {errors.last_name}    
                </span>
              )}
              
            </TXTRoundedDiv>
            <TXTRoundedDiv>
              <StyledInput
              placeholder="Title"
              name="title"
              onChange={(e)=>onChangeInput(e)}
              />
              {errors.title && (
                <span>
                {errors.title}
                </span>
              )}
            
            
            </TXTRoundedDiv>
            
            <TXTRoundedDiv>
              <StyledInput 
              type="file"
              onChange={(e)=>{
               onChangeImage(e)
              }}
              />
              <img src={picFile} width={350} height={200}
              />
            </TXTRoundedDiv>
            
            <Button type="submit" color="secondary" variant="contained" onClick={onButtonSubmit}>
                SAVE
            </Button>
            
         </StyledBox>

         <StyledBox flex={4}>

         </StyledBox>

         <StyledBox flex={4}>

         </StyledBox>
    </Stack>
   )
   
  }